<template>
    <div class="thumb">
        <template v-if="aspectRatioWidth && aspectRatioHeight">
            <aspect-ratio :ratio-width="aspectRatioWidth" :ratio-height="aspectRatioHeight">
                <v-lazy-image :src="src" class="thumnail" alt="boat-thumbnai-image" />
            </aspect-ratio>
        </template>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";
    import AspectRatio from "./atoms/AspectRatio.vue";
    export default {
        name: "CarouselImageThumbnail",
        components: {
            VLazyImage,
            AspectRatio
        },
        props: ['src', 'alt', "aspectRatioWidth", "aspectRatioHeight"]
    };
</script>
<style scoped lang="scss">
    .thumb {
        width: 150px;
        margin-right: 5px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
</style>